export default {
    defaultPath: '/Dashboard',
};